module.exports = __webpack_public_path__ + "2fe4b2c34954a591f76ce769bd04578b.png";